"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    sopqImages: ()=>sopqImages,
    HotelDetailCardsMessage: ()=>HotelDetailCardsMessage,
    getDefaultSopqRoomImage: ()=>getDefaultSopqRoomImage,
    transformListingProps: ()=>transformListingProps
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_carousel_namespaceObject = require("pcln-carousel");
const external_HotelFilterComponent_js_namespaceObject = require("./HotelFilterComponent.js");
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const HotelListingCard_js_namespaceObject = require("./HotelListingCard/HotelListingCard.js");
var HotelListingCard_js_default = /*#__PURE__*/ __webpack_require__.n(HotelListingCard_js_namespaceObject);
const LoadMore_js_namespaceObject = require("./HotelListingCard/components/LoadMore/LoadMore.js");
var LoadMore_js_default = /*#__PURE__*/ __webpack_require__.n(LoadMore_js_namespaceObject);
const external_useSetHotelPinOnMapHook_js_namespaceObject = require("./useSetHotelPinOnMapHook.js");
const useRealTimeContext_js_namespaceObject = require("../hooks/useRealTimeContext.js");
const ChatbotDataContext_js_namespaceObject = require("../context/ChatbotDataContext.js");
const sopqImages = [
    'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-3-2.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp',
    'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-3-3.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp',
    'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-4-1.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp',
    'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-3-1.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp',
    'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-2-1.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp',
    'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-4-3.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp',
    'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-2-3.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp'
];
const getDefaultSopqRoomImage = (starRating)=>{
    const imageRating = Number.isNaN(Number(starRating)) ? 0 : Math.floor(Number(starRating));
    return imageRating ? `https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-${imageRating}-1.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp` : sopqImages[0];
};
const transformAmenitiesText = (amenities)=>{
    if (amenities) {
        const amenityMap = {
            FINTRNT: 'Free Internet Access',
            FINTRAVL: 'Free Internet Available',
            FINTRPUB: 'Free Internet In Public Areas',
            FINTRRM: 'Free Internet In Room',
            'FREE WIFI': 'Free Internet In Room',
            PETALLOW: 'Pets Allowed',
            NSMKFAC: 'No Smoking Rooms/Facilities',
            BUSCNTR: 'Business Center',
            CASINO: 'Casino',
            FPRKING: 'Free Parking',
            BEDDING: 'Bedding',
            SPOOL: 'Swimming Pool',
            SPOOLIN: 'Indoor Swimming Pool',
            SPOOLOUT: 'Outdoor Swimming Pool',
            FITSPA: 'Fitness Center',
            SPA: 'Spa',
            FBRKFST: 'Free Breakfast',
            FBRKST: 'Free Breakfast',
            AIRSHUTTL: 'Airport Shuttle',
            FAIRSHUTTL: 'Free Airport Shuttle',
            HANDFAC: 'Accessible Rooms/Facilities',
            RESTRNT: 'Restaurant',
            BCHFRNT: 'Beachfront',
            FRIDGE: 'Fridge',
            MW: 'Microwave',
            TUB: 'Whirlpool',
            INCLUSIVE: 'All Inclusive',
            ADULTONLY: 'Adults Only',
            KITCHEN: 'Kitchen',
            KITCHENETTE: 'Kitchenette'
        };
        const firstTextMember = amenities.map((item)=>amenityMap[item]).join(', ');
        const secondTextMember = 'Fully Refundable Rates, Pay Later  Available';
        return [
            firstTextMember,
            secondTextMember
        ];
    }
    return '';
};
const transformListingProps = (hotel)=>{
    const { ratesSummary, totalReviewCount, starRating, images, hotelFeatures, overallGuestRating, location, name, displayStrikePrice, hotelType } = hotel ?? {};
    const imageSrc = 'SOPQ' === hotelType ? images?.[0]?.fastlyUrl || getDefaultSopqRoomImage(starRating) : images?.[0]?.fastlyUrl ?? '';
    return {
        imageSrc,
        amenitiesList: transformAmenitiesText(hotelFeatures?.highlightedAmenities),
        ratingsProps: {
            guestRating: totalReviewCount,
            hotelRating: starRating,
            overallRating: overallGuestRating
        },
        priceProps: {
            price: ratesSummary?.minPrice,
            totalPrice: ratesSummary?.grandTotal,
            grandTotalExcludingTax: ratesSummary?.grandTotalExcludingTax,
            grandTotalSavingsAmount: ratesSummary?.grandTotalSavingsAmount,
            grandTotalSavingsAmountExcludingTax: ratesSummary?.grandTotalSavingsAmountExcludingTax,
            grandTotalSavingsPctExcludingTax: ratesSummary?.grandTotalSavingsPctExcludingTax,
            grandTotalStrikeThroughPrice: ratesSummary?.grandTotalStrikeThroughPrice,
            grandTotalStrikeThroughPriceExcludingTax: ratesSummary?.grandTotalStrikeThroughPriceExcludingTax,
            currency: ratesSummary?.minCurrencyCodeSymbol,
            strikeThroughPrice: ratesSummary?.minStrikePrice,
            savingsPct: ratesSummary?.savingsPct,
            nightlyRateIncludingTaxesAndFees: ratesSummary.nightlyRateIncludingTaxesAndFees,
            nightlyRateExcludingTaxesAndFees: ratesSummary.nightlyRateExcludingTaxesAndFees,
            nightlyAllRoomsPriceExcludingTax: ratesSummary.nightlyAllRoomsPriceExcludingTax,
            nightlyAllRoomsStrikeThroughPriceExcludingTax: ratesSummary.nightlyAllRoomsStrikeThroughPriceExcludingTax,
            nightlyAllRoomsSavingsAmountExcludingTax: ratesSummary.nightlyAllRoomsSavingsAmountExcludingTax,
            nightlyInclusiveStrikeThroughPrice: ratesSummary.nightlyInclusiveStrikeThroughPrice,
            priceDisplayRegulation: ratesSummary?.priceDisplayRegulation,
            strikePriceExcludingTaxesAndFees: ratesSummary?.strikePriceExcludingTaxesAndFees,
            strikePriceIncludingTaxesAndFees: ratesSummary?.strikePriceIncludingTaxesAndFees,
            displayStrikePrice
        },
        headerText: {
            hotelName: name,
            neighborhoodName: location.neighborhoodName
        }
    };
};
const HotelDetailCardsMessage = (props)=>{
    (0, external_react_namespaceObject.useEffect)(()=>{
        analytics_js_default().log({
            label: 'HotelSearchResult',
            message: 'HOTEL_CARDS_DISPLAY',
            ...props?.args
        });
    }, []);
    const { isShowMoreListingCards } = props;
    const { isMobile } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const highRatedHotels = props.searchResult?.hotels?.filter((hotel)=>hotel.overallGuestRating > 7.5);
    const [currentSlide, setCurrentSlide] = (0, external_react_namespaceObject.useState)(0);
    const [offset, setOffset] = (0, external_react_namespaceObject.useState)(3);
    const [currentSlideOffset, setCurrentSlideOffset] = (0, external_react_namespaceObject.useState)(0);
    const [displaySopqOnly, setDisplaySopqOnly] = (0, external_react_namespaceObject.useState)(false);
    const { startRealTime } = (0, useRealTimeContext_js_namespaceObject.useRealTimeContext)();
    const hotelsLen = props.searchResult?.hotels?.length;
    const sortedHotels = props.searchResult?.hotels;
    const hasMoreHotels = offset < hotelsLen;
    const { hasSopqHotel, hasRtlHotel } = (props.searchResult?.hotels || []).reduce((flags, hotel)=>{
        if ('SOPQ' === hotel.hotelType) flags.hasSopqHotel = true;
        if ('SOPQ' !== hotel.hotelType) flags.hasRtlHotel = true;
        return flags;
    }, {
        hasSopqHotel: false,
        hasRtlHotel: false
    });
    const displayResult = (0, external_react_namespaceObject.useMemo)(()=>{
        if (isShowMoreListingCards) {
            const result = [
                ...sortedHotels?.slice(0, offset)
            ];
            result.push({
                type: hasMoreHotels ? 'loadMore' : 'endOfList'
            });
            return result;
        }
        if (displaySopqOnly) return props.searchResult?.hotels?.filter((hotel)=>'SOPQ' === hotel.hotelType);
        return props.displayVectorSearchResult ? props.searchResult?.hotels : highRatedHotels?.length ? props.searchResult?.hotels?.filter((hotel)=>hotel.overallGuestRating > 7.5)?.slice(0, 3) : props.searchResult?.hotels?.slice(0, 3);
    }, [
        props,
        offset,
        hasMoreHotels,
        displaySopqOnly
    ]);
    function onLoadMore() {
        analytics_js_default().log({
            label: 'LoadMoreListingHotels',
            message: 'LOAD_MORE_HOTELS_CLICKED'
        });
        if (offset < props.searchResult?.hotels?.length) {
            setCurrentSlide(currentSlide + 3);
            setOffset(offset + 3);
            setCurrentSlideOffset(currentSlideOffset + 1);
        }
    }
    (0, external_useSetHotelPinOnMapHook_js_namespaceObject.useSetHotelPinOnMapHook)({
        displaySopqOnly,
        displayResult,
        args: props?.args
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                maxWidth: startRealTime && isMobile ? '370px' : null,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_carousel_namespaceObject.Carousel, {
                    arrowPositions: "side",
                    showForwardBackBtns: true,
                    visibleSlides: 2,
                    onSlideChange: function() {},
                    overflowAllowancePxX: isMobile ? 16 : 32,
                    currentSlide: currentSlide,
                    displayArrowsMobile: isMobile,
                    children: displayResult?.map(function(hotel, index) {
                        if ('loadMore' === hotel.type && isShowMoreListingCards) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(LoadMore_js_default(), {
                                onLoadMore: onLoadMore
                            })
                        }, "load_more_listing_card");
                        if ('endOfList' === hotel.type) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {}, 'end_of_list_listing_card');
                        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(HotelListingCard_js_default(), {
                                listingProps: transformListingProps(hotel),
                                hotel: hotel,
                                args: props?.args
                            })
                        }, String(hotel.hotelId));
                    })
                })
            }),
            startRealTime ? null : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_HotelFilterComponent_js_namespaceObject.HotelFilterComponent, {
                ...props,
                hasSopqHotel: hasSopqHotel,
                hasRtlHotel: hasRtlHotel,
                displaySopqOnly: displaySopqOnly,
                toggleOnlyExpressDealClick: function() {
                    analytics_js_default().log({
                        label: 'HotelSearchResult',
                        message: 'TOGGLE_EXPRESS_DEAL_RESULTS_BUTTON_CLICKED',
                        ...props?.args
                    });
                    setDisplaySopqOnly(!displaySopqOnly);
                }
            })
        ]
    });
};
exports.HotelDetailCardsMessage = __webpack_exports__.HotelDetailCardsMessage;
exports.getDefaultSopqRoomImage = __webpack_exports__.getDefaultSopqRoomImage;
exports.sopqImages = __webpack_exports__.sopqImages;
exports.transformListingProps = __webpack_exports__.transformListingProps;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "HotelDetailCardsMessage",
    "getDefaultSopqRoomImage",
    "sopqImages",
    "transformListingProps"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
